module.exports = __webpack_public_path__ + "static/media/portfolio-img-2.7742191a.png";